<template>
  <div class="mb-3">
    <label class="form-label d-block">{{ label }}</label>
    <template v-for="opt in OPTIONS" :key="opt.val">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" :id="uid + opt.val" :value="opt.val"
          :checked="modelValue === opt.val" @change="$emit('update:modelValue', opt.val)" />
        <label class="form-check-label" :for="uid + opt.val">{{ opt.text }}</label>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
const OPTIONS = [
  { val: 'any', text: 'Неважно' },
  { val: 'no', text: 'Нет' },
  { val: 'yes', text: 'Есть' }
]

const props = defineProps({ modelValue: String, label: String })
const uid = computed(() => props.label.replace(/\s+/g, ''))
</script>
